// Single registry of "what's new" across the user menu (the avatar dropdown).
// Each top-level key is a menu item; its value is an object of named flags —
// one per new feature living inside that item. An item is "new" if ANY of
// its flags is true; the whole menu is "new" if ANY item is.
//
// To announce something new: add/flip a flag here. The item's own badge
// (see Dropdown/index.jsx) and the avatar dot (see ../index.jsx) both update
// automatically — no other file needs to change. To retire it, flip the flag
// back to false (or remove it).
const userMenuFeatures = {
  extras: {
    chromeExtension: false
  }
};

const hasNew = (flags) => Object.values(flags || {}).some(Boolean);

// True if this user-menu item (by key, e.g. 'extras') has something new.
export const isMenuItemNew = (key) => hasNew(userMenuFeatures[key]);

// True if ANY user-menu item has something new — drives the avatar dot.
export const isUserMenuNew = () => Object.keys(userMenuFeatures).some(isMenuItemNew);

export default userMenuFeatures;
